import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router} from '@angular/router';
import {RouteName} from '@ew/enums';
import {GlobalUserStore} from '@ew/global-user';
import {firstValueFrom, of} from 'rxjs';

/**
 * A guard function that checks if the user is authenticated.
 *
 * @return {Promise<boolean>} A promise that resolves to true if the user is authenticated, otherwise false.
 */
export const createProfileGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
): Promise<boolean> => {
  const globalStore = inject(GlobalUserStore);
  const router = inject(Router);

  if (!globalStore.user().id) {
    router.navigateByUrl(RouteName.Empty);
    return false;
  }

  if (globalStore.user().role) {
    router.navigateByUrl(RouteName.Empty);
    return false;
  }

  return await firstValueFrom(of(true));
};
